module.exports = __webpack_public_path__ + "static/media/top-nfts-3.48e36deb.jpg";